import { beautifyClinicName, beautifyName } from '@/utils/beautifyNames';
import upperCase from 'lodash/upperCase';
import moment from 'moment';

export function getInitials(val, qty = 2) {
  let splited = val.split(' ').slice(0, qty);
  if (!splited.length)
    return console.error('The quantity param must be greater than 0');

  return splited.map(item => upperCase(item.substring(0, 1))).join(' ');
}

export function isDoctor(profileType) {
  const acceptedTypes = [
    'MEDICO_CLINICO',
    'MEDICO_ESPECIALISTA',
    'PROFISSIONAL_SAUDE',
  ];
  return !!acceptedTypes.includes(profileType);
}

export function isSpecialist(profileType) {
  return profileType === 'MEDICO_ESPECIALISTA';
}

export const dictUser = ({
  token,
  email,
  idClinica,
  idProfissional,
  idUsuario,
  nome,
  nomeClinica,
  perfil,
  roles,
  saudacao,
  sobrenome,
  urlFotoClinica,
  urlFotoPerfil,
  tokenProfissional,
  conselhoProfissional,
}) => {
  const obj = {
    token,
    id: idUsuario,
    title: saudacao,
    firstName: beautifyName(nome),
    lastName: beautifyName(sobrenome),
    email,
    profileType: perfil,
    isDoctor: isDoctor(perfil),
    isSpecialist: isSpecialist(perfil),
    profileImage: {
      url: urlFotoPerfil,
    },
    roles,
    clinic: {
      id: idClinica,
      beautifiedName: beautifyClinicName(nomeClinica),
      name: nomeClinica,
      imageUrl: urlFotoClinica,
      initials: getInitials(nomeClinica),
    },
    professionalId: idProfissional,
    council: conselhoProfissional,
    professionalToken: tokenProfissional,
  };

  return obj;
};

export const isTokenExpired = timestamp =>
  moment.unix(timestamp).isBefore(moment());
